module.exports = __webpack_public_path__ + "static/media/titlecard_faveinsights.b7b2ac9b.jpg";